module.exports = __webpack_public_path__ + "static/media/fig_9a.9687f52a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_9a.jpg
// module id = 684
// module chunks = 0